import { VymlGame } from '@frontend/sports/types/components/banners/vyml';

import { CrossSaleTracking } from './cross-sale-tracking.model';

export enum ChannelIds {
    Android = 'AW',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    IOS = 'IW',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    WC = 'WC',
}

export interface TickModel {
    isDigit?: boolean;
    isCurrency?: boolean;
    isSeparator?: boolean;
    currency?: string;
    digit?: number;
    separator?: string;
}

export interface JackpotValues {
    [jackpotGroup: string]: number;
}

export abstract class JackpotEvent {}

export class JackpotIncrementEvent extends JackpotEvent {
    constructor(public incrementBy: number) {
        super();
    }
}

export interface VymlGamesModel extends VymlGame {
    tilePosition: number;
}

export class JackpotRefreshEvent extends JackpotEvent {
    constructor(public newValues: JackpotValues) {
        super();
    }
}
export interface BannerTrackingModel {
    crossSellProduct: string;
    lobbyPosition: string;
    crossSellName: string;
    gameName: string;
    url: string;
    crossSellActionEvent: string;
    index?: number;
}

export interface GameTrackingModel {
    name: string;
    index: number;
    displayName: string;
    lobbyPosition: string;
    pageName: string;
    url: string;
}

export interface VymlTrackingModel extends GameTrackingModel {
    section: CrossSaleTracking;
}

export interface GymlTrackingModel extends GameTrackingModel {
    provider: string;
}

export enum KycStatus {
    Default = 0,
    Verified = 1,
    NonVerified = 2,
}
